import { Box, Skeleton } from "@mui/material";
import { tokens } from "../tokens";

interface Props {
  /** 2 for the side-by-side comparison, 1 for the single-file view. */
  columns: 1 | 2;
  height: number;
}

/** Varied widths so the placeholder reads as code rather than a block. */
const LINE_WIDTHS = [
  "78%",
  "42%",
  "60%",
  "86%",
  "54%",
  "30%",
  "70%",
  "48%",
  "64%",
  "38%",
  "82%",
  "56%",
  "44%",
  "72%",
  "34%",
  "62%",
];

const SkeletonColumn = ({ height }: { height: number }) => (
  <Box
    sx={{
      padding: "14px 16px",
      display: "flex",
      flexDirection: "column",
      gap: 0.85,
      height,
      overflow: "hidden",
    }}
  >
    {LINE_WIDTHS.map((width, index) => (
      <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Skeleton
          variant="text"
          width={14}
          sx={{ fontSize: 11.5, flexShrink: 0, opacity: 0.5 }}
        />
        <Skeleton variant="text" width={width} sx={{ fontSize: 11.5 }} />
      </Box>
    ))}
  </Box>
);

/**
 * Placeholder shown while a revision body is being fetched and while the diff
 * is being computed. It occupies the same height as the real content so the
 * dialog does not resize once the data lands.
 */
const CodeSkeleton = ({ columns, height }: Props) => (
  <Box
    aria-busy="true"
    aria-label="Loading code"
    sx={{
      backgroundColor: tokens.codeBg,
      display: "grid",
      gridTemplateColumns: columns === 2 ? "1fr 1fr" : "1fr",
      "& > :first-of-type": {
        borderRight: columns === 2 ? `1px solid ${tokens.border}` : "none",
      },
    }}
  >
    {Array.from({ length: columns }).map((_, index) => (
      <SkeletonColumn key={index} height={height} />
    ))}
  </Box>
);

export default CodeSkeleton;
